"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcrossConfigStore__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "UpdatedGlobalConfig",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "key",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "UpdatedTokenConfig",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "globalConfig",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "l1TokenConfig",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "updateGlobalConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "updateTokenConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AcrossConfigStore__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AcrossConfigStore__factory = AcrossConfigStore__factory;
AcrossConfigStore__factory.bytecode = _bytecode;
AcrossConfigStore__factory.abi = _abi;
